import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { canDeactivateGuard } from './core/guards/can-deactivate.guard';
import { dataGuard } from './core/guards/data.guard';
import { lookupGuard } from './core/guards/lookups.guard';
import { loginGuard } from './core/guards/login.guard';

export const routes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () => import('./auth/auth-callback/auth-callback.component').then(c => c.AuthCallbackComponent),
  },
  {
    path: 'auth/logout',
    loadComponent: () => import('./auth/auth-logout/auth-logout.component').then(c => c.AuthLogoutComponent),
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./pages/forbidden/forbidden.component').then(c => c.ForbiddenComponent),
  },
  {
    path: '',
    canActivate: [loginGuard],
    loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
    title: 'SAL Training Modules - Login',
  },
  {
    path: 'dashboard',
    canActivate: [autoLoginPartialRoutesGuard, dataGuard, lookupGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(c => c.DashboardComponent),
    title: 'SAL Training Modules - Dashboard',
  },
  {
    path: 'survey/:id',
    canActivate: [autoLoginPartialRoutesGuard, dataGuard, lookupGuard],
    canDeactivate: [canDeactivateGuard],
    loadComponent: () => import('./pages/survey/survey.component').then(c => c.SurveyComponent),
    title: 'SAL Training Modules - Survey',
    children: [
      {
        path: ':page',
        children: [],
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(c => c.NotFoundComponent),
  },
];
